import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { StudentActivitiesList } from './StudentActivitiesList'
import { StudentActivityReportList } from './StudentActivityReportList'
import { StudentAwardsList } from './StudentAwardsList'
import { StudentAwardsReportList } from './StudentAwardsReportList'

const StudentActivitiesAwards = () => {
	const { studentId } = useParams()
	const { user } = useAuth()
	const isInstructorView = user?.role === 'Instructor'
	const effectiveStudentId = isInstructorView ? studentId : user?.id
	const [activeTab, setActiveTab] = useState('studentactivities')

	const toggle = (tab) => {
		if (activeTab !== tab) setActiveTab(tab)
	}

	return (
		<StudentTopMenuLayout activeMenu="Activities/Awards" pageName="ActivitiesAwards">
			<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
				<div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
					<div className="d-flex align-items-center">
						<button
							type="button"
							className="btn btn-link p-0 me-2"
							data-bs-toggle="collapse"
							data-bs-target="#collapseActivitiesAwards"
							aria-expanded="false"
							aria-controls="collapseActivitiesAwards"
						>
							<i className="fa fa-chevron-down"></i>
						</button>
						<h5 className="mb-0 text-dark d-inline-block">Activities & Awards</h5>
					</div>
				</div>
				<div className="collapse" id="collapseActivitiesAwards">
					<div className="card-body bg-white">
						<Nav tabs>
							<NavItem>
								<NavLink
									className={activeTab === 'studentactivities' ? 'active' : ''}
									onClick={() => toggle('studentactivities')}
									style={{ cursor: 'pointer' }}
								>
									Student Activities
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									className={activeTab === 'studentactivityreports' ? 'active' : ''}
									onClick={() => toggle('studentactivityreports')}
									style={{ cursor: 'pointer' }}
								>
									Student Activity Reports
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									className={activeTab === 'studentawards' ? 'active' : ''}
									onClick={() => toggle('studentawards')}
									style={{ cursor: 'pointer' }}
								>
									Student Awards
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									className={activeTab === 'studentawardsreport' ? 'active' : ''}
									onClick={() => toggle('studentawardsreport')}
									style={{ cursor: 'pointer' }}
								>
									Student Awards Report
								</NavLink>
							</NavItem>
						</Nav>

						<TabContent activeTab={activeTab} className="mt-3">
							<TabPane tabId="studentactivities">
								<StudentActivitiesList studentId={effectiveStudentId} isStudentView={!isInstructorView} />
							</TabPane>
							<TabPane tabId="studentactivityreports">
								<StudentActivityReportList studentId={effectiveStudentId} isStudentView={!isInstructorView} />
							</TabPane>
							<TabPane tabId="studentawards">
								<StudentAwardsList studentId={effectiveStudentId} isStudentView={!isInstructorView} />
							</TabPane>
							<TabPane tabId="studentawardsreport">
								<StudentAwardsReportList studentId={effectiveStudentId} isStudentView={!isInstructorView} />
							</TabPane>
						</TabContent>
					</div>
				</div>
			</div>
		</StudentTopMenuLayout>
	)
}

export { StudentActivitiesAwards }
